// extracted by mini-css-extract-plugin
module.exports = {"spinnerWrapper":"DashSpinner_spinnerWrapper__shO_f","dashSpinner":"DashSpinner_dashSpinner___mYLL","dash":"DashSpinner_dash___Y8K2","dashPulse":"DashSpinner_dashPulse__UI0G6"};